import React, { useState, useEffect } from 'react';
import HttpHelper from '../service/httpService';
import swal from 'sweetalert';
import { useHistory } from 'react-router-dom';
import { SystemDashboardLayout } from '../library';
import HeaderDashboard from '../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Opportunities from '../Components/Opportunities/Opportunities'
import { SystemGridAndForm } from 'library/form/SystemGridForm';
import OpportunitiesForm from '../Components/Opportunities/AddOpportunities';


const HomeDashboard = (props: any) => {
    const [filter, setFilter] = useState(true);
    const [data, setData] = useState();

    const history = useHistory();

    useEffect(() => {
        HttpHelper.get('Opportunity')
            .then((response) => {               
                setData(response.data.Data);
            })
    }, [])

    const deleteOpportunity = async (OpportunityId: number) => {
        if (OpportunityId == null || OpportunityId == undefined)
            return false;

        swal("Are you sure, you want to delete this opportunity?", { buttons: ["cancel", "yes"] }).then(async (willDelete) => {
            if (willDelete) {
                await HttpHelper.delete("Opportunity/" + OpportunityId).then((response) => {
                    if (response.status == 200) {
                        props.showToast('Success', 'Opportunity deleted successfully');
                    }
                    else {
                        props.showToast('error', response.data);
                    }
                }).catch((error) => {
                    console.log(error);
                })
            }
        })
    }

    const onRowClick = (event: any) => {
        if (event && event.dataItem.PrimaryKeyEncrypted) {     
            props.history.push({
                pathname: `/edit-opportunity/${event.dataItem.PrimaryKeyEncrypted}`,
                data: event.dataItem
            });
        }
    }

    const onAdd = () => {
        props.history.push({
            pathname: '/add-opportunity',
        });
        return ""
    }

    return (<>
        <div className="opportunity-dashboard DashboardWrapperChild">           
            <div className="contentWrapper">
                <HeaderDashboard title="Top" tagLine="" />
                <div className="container-fluid mt-80">
                    <div className="row">
                        <div className="col-md-12 Opportunity-grid">
                            <SystemDashboardLayout>
                                <SystemGridAndForm label="Opportunities" form={OpportunitiesForm} grid={Opportunities} securityObject="Top.Opportunity" onRowClick={onRowClick} onAdd={onAdd}/>
                            </SystemDashboardLayout>
                        </div> 
                    </div>
                </div>
            </div>
        </div>

        <div className="filterPopUpWrapper" style={{ display: `${filter == true ? 'none' : 'block'}` }}>
            <div className="crossFilter" onClick={() => {
                setFilter(!filter);
            } }>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                </svg>
            </div>
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-12">
                        <div className="searchFormDateFilter w-100">
                            <div className="formGroupDate">
                                <label>End Date:</label>
                                <input type="text" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mt-2">
                        <div className="filterCheckBox scrollChange">
                            <h6>Filter by Location</h6>
                            <div className="filtercheckboxWrapper">
                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">All</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">38-401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401CAT</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401K</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401KLN</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401RTH</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">54U401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">63N401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">ADVPAY</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-AZ1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-FL1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-TX1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-TX2</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DNTL02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DNTL04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES2</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES9</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">GARN01</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">GARN02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LEG-F</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LEG-I</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFE02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFE04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LTD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LTD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED01</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED06</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED07</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED08</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">PET06</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">STD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">STD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">VISN02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">VISN04</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mt-2">
                        <div className="filterCheckBox scrollChange">
                            <h6>Filter by NAICS</h6>
                            <div className="filtercheckboxWrapper">
                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">All</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">38-401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401CAT</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401K</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401KLN</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401RTH</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">54U401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">63N401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">ADVPAY</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-AZ1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-FL1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-TX1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-TX2</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DNTL02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DNTL04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES2</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES9</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">GARN01</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">GARN02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LEG-F</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LEG-I</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFE02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFE04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LTD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LTD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED01</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED06</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED07</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED08</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">PET06</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">STD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">STD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">VISN02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">VISN04</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mt-2">
                        <div className="filterCheckBox scrollChange">
                            <h6>Filter by Agency</h6>
                            <div className="filtercheckboxWrapper">
                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">All</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">38-401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401CAT</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401K</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401KLN</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401RTH</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">54U401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">63N401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">ADVPAY</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-AZ1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-FL1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-TX1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-TX2</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DNTL02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DNTL04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES2</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES9</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">GARN01</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">GARN02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LEG-F</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LEG-I</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFE02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFE04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LTD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LTD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED01</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED06</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED07</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED08</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">PET06</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">STD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">STD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">VISN02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">VISN04</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mt-2">
                        <div className="filterCheckBox scrollChange">
                            <h6>Filter by Workflow Stage</h6>
                            <div className="filtercheckboxWrapper">
                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">All</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">38-401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401CAT</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401K</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401KLN</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401RTH</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">54U401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">63N401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">ADVPAY</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-AZ1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-FL1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-TX1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-TX2</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DNTL02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DNTL04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES2</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES9</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">GARN01</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">GARN02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LEG-F</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LEG-I</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFE02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFE04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LTD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LTD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED01</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED06</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED07</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED08</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">PET06</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">STD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">STD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">VISN02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">VISN04</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mt-2">
                        <div className="filterCheckBox scrollChange">
                            <h6>Filter by Opportunity Status</h6>
                            <div className="filtercheckboxWrapper">
                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">All</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">38-401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401CAT</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401K</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401KLN</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">401RTH</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">54U401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">63N401</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">ADVPAY</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-AZ1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-FL1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-TX1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">CS-TX2</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DNTL02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DNTL04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES1</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES2</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">DUES9</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">GARN01</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">GARN02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LEG-F</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LEG-I</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFE02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LIFE04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LTD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">LTD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED01</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED06</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED07</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">MED08</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">PET06</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">STD02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">STD04</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">VISN02</label>
                                </div>

                                <div className="filtercheckboxContainer">
                                    <input type="checkbox" />
                                    <label className="normal-text">VISN04</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>      
    </>)
}

export default HomeDashboard;